import type { DocumentsListing } from '@contracts/document/DocumentResponse';
import { getLastPartOfPath } from '@src/documents/hooks/useFindAllDocumentsForOrder';

export const DocumentAssembler = {
  toFormData: (documents: DocumentsListing[]) => {
    return documents.map((doc) => ({
      documentId: doc.id,
      name: getLastPartOfPath(doc.key),
      displayName: doc.displayName,
      sendToClient: doc.sendToClient,
      showToClient: doc.showToClient,
    }));
  },
};
